// import PlaceInfoData from "./../../places/PlaceInfoData";
// import EducationalGroupTime from "./EducationalGroupTime";

export default class EducationalGroupPlace {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.placeToken = "";
    // this.placeInfoData = new PlaceInfoData();
    this.educationalGroupTimesData = [];
    // this.educationalGroupTimesData = [new EducationalGroupTime()];
  }
  fillData(data) {
    if (data) {
      this.placeToken = data.placeToken || "";
      // this.placeInfoData.fillData(data.placeInfoData);
      this.educationalGroupTimesData = data.educationalGroupTimesData || [];
    } else {
      this.setInitialValue();
    }
  }
}
